import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, apiUrl } from "../../../utils/apis";
import type {
    Lawyer,
    LawyerPayload,
    PaginatedResponse,
} from "./types";


export const lawyerApi = createApi({
    reducerPath: "lawyerApi",

    baseQuery: fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers) => {
            const token = sessionStorage.getItem("token");
            headers.set("Content-Type", "application/json");
            if (token) headers.set("Authorization", `Bearer ${token}`);
            return headers;
        },
    }),

    tagTypes: ["Lawyer"],

    endpoints: (builder) => ({
        // 🔹 GET LAWYER LIST
        getLawyerList: builder.query<PaginatedResponse<Lawyer>, void>({
            query: () => ({
                url: apiUrl.lawyerUrl,
                method: "GET",
            }),
            providesTags: ["Lawyer"],
        }),

        // 🔹 CREATE LAWYER (POST)
        createLawyer: builder.mutation<Lawyer, LawyerPayload>({
            query: (body) => ({
                url: apiUrl.lawyerUrl,
                method: "POST",
                body,
            }),
            invalidatesTags: ["Lawyer"],
        }),

        // 🔹 UPDATE LAWYER (PUT)
        updateLawyer: builder.mutation<Lawyer, { id: number | string; data: Partial<LawyerPayload> }>({
            query: ({ id, data }) => ({
                url: `${apiUrl.lawyerUrl}${id}/`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Lawyer"],
        }),

        // 🔹 DELETE LAWYER
        deleteLawyer: builder.mutation<{ success: boolean }, number>({
            query: (id) => ({
                url: `${apiUrl.lawyerUrl}${id}/`,
                method: "DELETE",
            }),
            invalidatesTags: ["Lawyer"],
        }),
        // 🔹 ACTIVATE / DEACTIVATE LAWYER
        activeLeLawyerStatus: builder.mutation<{ success: boolean; message?: string }, { id: number; action: "activate" | "deactivate" }>({
            query: ({ id, action }) => ({
                url: `${apiUrl.ActiveLawyer}${id}/`,
                method: "POST",
                body: { action },
            }),
            invalidatesTags: ["Lawyer"],
        }),
        searchLawyers: builder.query< any,{ search?: string; search_by?: string }>({
            query: ({ search = "", search_by = "" }) => ({
                url: apiUrl.searchLawyer,
                params: {
                    search,
                    search_by,
                },
            }),
            providesTags: ["Lawyer"],
        }),

           LawyersDeshBoard: builder.query< any,{ lawyer_id?: string; limit?: number }>({
            query: ({ lawyer_id = "", limit = 10 }) => ({
                url: apiUrl.dashboardApi,
                params: {
                
                    lawyer_id,
                    limit,
                },
            }),
            providesTags: ["Lawyer"],
        }),

    }),

});

export const {
    useGetLawyerListQuery,
    useCreateLawyerMutation,
    useUpdateLawyerMutation,
    useDeleteLawyerMutation,
    useActiveLeLawyerStatusMutation,
   useLazySearchLawyersQuery,
   useLawyersDeshBoardQuery
} = lawyerApi;


